<template>
  <component
    :is="linkComponent"
    class="block rounded-sm py-3 text-subtle hover:state-layer-neutral"
    :class="[routeMatches ? 'router-link-active' : '', classes]"
    v-bind="componentProps"
  >
    <slot />
  </component>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import { useRoute } from 'vue-router'
const route = useRoute()

const routeMatches = computed(() => {
  if (!props.activeRoutes || !route.name) return false
  return props.activeRoutes.includes(route.name as string)
})

const props = defineProps<{
  to?: RouteLocationRaw
  activeRoutes?: Array<string>
  disableRouterActive?: boolean
  nestLevel?: 0 | 1 | 2
}>()

const isExternalLink = computed(() => typeof props.to === 'string' && props.to.startsWith('http'))
const linkComponent = computed(() => {
  if (!props.to) return 'button'
  return isExternalLink.value ? 'a' : 'RouterLink'
})
const componentProps = computed(() => {
  if (!props.to) return { type: 'button' }
  if (isExternalLink.value) return { href: props.to, target: '_blank' }
  const routerLinkProps: Record<string, unknown> = { to: props.to }
  if (props.disableRouterActive) {
    routerLinkProps.activeClass = ''
    routerLinkProps.exactActiveClass = ''
  }
  return routerLinkProps
})

const classes = computed(() => {
  switch (props.nestLevel) {
    case 1:
      return 'text-body-s px-3'
    case 2:
      return 'text-body-s pl-14 pr-5'
    default:
      return 'text-body-s px-5'
  }
})
</script>

<style scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.router-link-active {
  @apply bg-primary-alpha-strongest text-main;
}
</style>
